import { render, staticRenderFns } from "./errorSnackbar.vue?vue&type=template&id=0fa6f26a&scoped=true"
import script from "./errorSnackbar.vue?vue&type=script&lang=js"
export * from "./errorSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa6f26a",
  null
  
)

export default component.exports